import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import FooterTwo from '../../../components/Footer/index';
import ScrollToTop from '../../../components/ScrollTop';
import SideManu from './sidebar';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Banner from '../images/banners/ala_events.webp';
import axios from 'axios';
import jsPDF from 'jspdf';
import './formStyles.css';

/* ─── Scoped styles for the redesigned modal only ──────────────────────────── */
const AdvancedAppliation = () => {
    const backendUrl = process.env.REACT_APP_DATABASEURL;
    const [showSuccess, setShowSuccess] = useState(false);
    let tab1 = "Completed Events",
        tab2 = "Ongoing Event",
        tab3 = "Upcoming Event";
    const tabStyle = 'nav nav-tabs';
    const [selectedIndex, setSelectedIndex] = useState(2);
    const nodata = "Currently No Event Scheduled";

    const [countries, setCountries] = useState([]);
    useEffect(() => {
        fetch("https://restcountries.com/v3.1/all?fields=name,idd")
            .then((res) => res.json())
            .then((data) => {
                const countryList = data
                    .map((country) => ({
                        name: country.name.common,
                        code: country.idd?.root
                            ? country.idd.root + (country.idd.suffixes ? country.idd.suffixes[0] : "")
                            : "",
                    }))
                    .filter((c) => c.code)
                    .sort((a, b) => a.name.localeCompare(b.name));
                setCountries(countryList);
            })
            .catch((err) => console.error(err));
    }, []);

    const [ongoingEvent, setongoingEvent] = useState([]);
    const [upcomingEvent, setupcomingEvent] = useState([]);
    const [completedEvent, setcompletedEvent] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const today = new Date();

    const RandomId = () => {
        const pad = (num) => String(num).padStart(2, "0");
        const year = String(today.getFullYear()).slice(-2);
        const month = pad(today.getMonth() + 1);
        const day = pad(today.getDate());
        const hour = pad(today.getHours());
        const minute = pad(today.getMinutes());
        const second = pad(today.getSeconds());
        return `${year}${month}${day}${hour}${minute}${second}`;
    };

    const id = RandomId();
    const [formData, setFormData] = useState({
        applicationId: id,
        participantName: "",
        salutation: '',
        department: '',
        email: "",
        contactNo: "",
        whatsappNo: "",
        collegeName: "",
        collegeAddress: "",
        state: "",
        category: "",
        designation: "",
        nationality: "",
        event_amount: "",
        event_name: "",
        countryCode: "+91",
    });

    // const finalPhone = `${formData.countryCode}${formData.contactNo}`;
    const finalPhone = `${formData.nationality === "India" ? "+91" : formData.countryCode}${formData.contactNo}`;
    const [paymentStatus, setPaymentStatus] = useState(null);
    const { event_amount } = formData;

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const createOrder = async (orderAmount, currency) => {
        try {
            const response = await axios.post(`${backendUrl}/payment-events/create-order`, {
                amount: orderAmount,
                currency: currency,
                receipt: `receipt_${Date.now()}`,
                notes: { description: 'Event Registration' },
            });
            const data = await response.data;
            if (!data.success) throw new Error(data.message || 'Failed to create order');
            return data;
        } catch (error) {
            console.error('Error creating order:', error);
            throw error;
        }
    };

    const downloadReceipt = () => {
        if (!paymentStatus || !paymentStatus.receiptData) return;
        const { receiptData, paymentId } = paymentStatus;
        const doc = new jsPDF();
        const receiptDate = new Date().toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata', year: 'numeric', month: 'long',
            day: 'numeric', hour: '2-digit', minute: '2-digit'
        });
        const primaryColor = [12, 106, 176];
        const secondaryColor = [76, 175, 80];
        const textColor = [51, 51, 51];

        doc.setFillColor(...primaryColor);
        doc.rect(0, 0, 210, 40, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(24); doc.setFont('helvetica', 'bold');
        doc.text('ADITYA UNIVERSITY', 105, 18, { align: 'center' });
        doc.setFontSize(14); doc.setFont('helvetica', 'normal');
        doc.text('Receipt', 105, 28, { align: 'center' });
        doc.setTextColor(...textColor);
        doc.setFontSize(9); doc.setFont('helvetica', 'normal');
        doc.text(`Receipt Date: ${receiptDate}`, 20, 50);
        doc.text(`Application ID: ${receiptData.applicationId}`, 20, 56);
        doc.setDrawColor(200, 200, 200);
        doc.line(20, 62, 190, 62);

        let yPos = 72;
        doc.setFontSize(12); doc.setFont('helvetica', 'bold');
        doc.setTextColor(...primaryColor);
        doc.text('PARTICIPANT DETAILS', 20, yPos);
        doc.setFontSize(10); doc.setFont('helvetica', 'normal');
        doc.setTextColor(...textColor);
        [
            ['Name:', `${receiptData.salutation}.${receiptData.participantName}`],
            ['Email:', receiptData.email],
            ['Contact No:', receiptData.contactNo],
            ['Whatsapp No:', receiptData.whatsappNo],
            ['Department:', receiptData.department],
            ['Designation:', receiptData.designation],
        ].forEach(([label, val]) => {
            yPos += 6; doc.text(label, 20, yPos); doc.text(String(val), 60, yPos);
        });

        yPos += 8; doc.setDrawColor(200, 200, 200); doc.line(20, yPos, 190, yPos);
        yPos += 8; doc.setFontSize(12); doc.setFont('helvetica', 'bold');
        doc.setTextColor(...primaryColor); doc.text('ORGANIZATION DETAILS', 20, yPos);
        doc.setFontSize(10); doc.setFont('helvetica', 'normal'); doc.setTextColor(...textColor);
        yPos += 8; doc.text('College/Institute:', 20, yPos);
        const collegeLines = doc.splitTextToSize(receiptData.collegeName, 120);
        doc.text(collegeLines, 60, yPos); yPos += collegeLines.length * 6;
        doc.text('Address:', 20, yPos);
        const addrLines = doc.splitTextToSize(receiptData.collegeAddress, 120);
        doc.text(addrLines, 60, yPos); yPos += addrLines.length * 6;
        doc.text('State:', 20, yPos); doc.text(String(receiptData.state), 60, yPos);

        yPos += 8; doc.setDrawColor(200, 200, 200); doc.line(20, yPos, 190, yPos);
        yPos += 8; doc.setFontSize(12); doc.setFont('helvetica', 'bold');
        doc.setTextColor(...primaryColor); doc.text('EVENT DETAILS', 20, yPos);
        doc.setFontSize(10); doc.setFont('helvetica', 'normal'); doc.setTextColor(...textColor);
        yPos += 8; doc.text('Event Name:', 20, yPos);
        const evLines = doc.splitTextToSize(receiptData.event_name, 120);
        doc.text(evLines, 60, yPos); yPos += evLines.length * 6;
        doc.text('Event Amount:', 20, yPos); doc.setFont('helvetica', 'bold');
        doc.text(String(receiptData.event_amount), 60, yPos); doc.setFont('helvetica', 'normal');

        yPos += 8; doc.setDrawColor(200, 200, 200); doc.line(20, yPos, 190, yPos);
        yPos += 8; doc.setFillColor(...secondaryColor); doc.rect(18, yPos - 5, 174, 32, 'F');
        doc.setFontSize(12); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
        doc.text('PAYMENT DETAILS', 20, yPos);
        doc.setFontSize(10); doc.setFont('helvetica', 'normal');
        yPos += 8; doc.text('Payment Status:', 20, yPos); doc.setFont('helvetica', 'bold');
        doc.text('SUCCESS', 60, yPos); doc.setFont('helvetica', 'normal');
        yPos += 6; doc.text('Payment ID:', 20, yPos); doc.text(String(paymentId), 60, yPos);
        yPos += 6; doc.text('UTR ID:', 20, yPos); doc.text(String(receiptData.utr), 60, yPos);
        yPos += 6; doc.text('Amount Paid:', 20, yPos); doc.setFont('helvetica', 'bold');
        doc.setFontSize(11); doc.text(String(receiptData.event_amount), 60, yPos);

        doc.setFontSize(8); doc.setFont('helvetica', 'italic'); doc.setTextColor(100, 100, 100);
        doc.text('Thank you for registering with Aditya University!', 105, 270, { align: 'center' });
        doc.text('For queries, contact: ala@adityauniversity.in | https://adityauniversity.in/', 105, 276, { align: 'center' });
        doc.setDrawColor(...primaryColor); doc.setLineWidth(0.5); doc.rect(10, 10, 190, 277);
        doc.save(`Receipt_${receiptData.applicationId}_${paymentId}.pdf`);
    };

    const finalDesignation = formData.designation === "Other" ? formData.otherDesignation : formData.designation;
    const finalDepartment = formData.department === "Other" ? formData.otherDepartment : formData.department;

    const verifyPayment = async (paymentData) => {
        try {
            const response = await axios.post(`${backendUrl}/payment-events/verify-payment`, paymentData);
            const data = await response.data;
            if (data.success) {
                const payload = {
                    ...formData,
                    designation: finalDesignation,
                    department: finalDepartment,
                    event_name: selectedEvent?.event_name,
                    event_amount: selectedEvent.event_amount,
                    currency: formData.nationality === "India" ? "INR" : "USD",
                    whatsappLink: selectedEvent?.whatsappLink,
                    order_id: data.orderId,
                    payment_id: data.paymentId,
                    utr: data.utr,
                    payment_status: 'Success',
                    contactNo: finalPhone,
                    amount: data.amount,
                };
                const registrationResponse = await axios.post(`${backendUrl}api/add-event-registrations`, payload);
                setPaymentStatus({
                    success: true, message: 'Payment successful!',
                    paymentId: data.paymentId, orderId: data.orderId,
                    utr: data.utr, amount: data.amount, receiptData: payload,
                });
                if (registrationResponse.data.success === true) {
                    setShowSuccess(true);
                } else {
                    alert(`⚠️ Payment Success But Registration Failed! ${registrationResponse.data.message || 'Please try again.'}`);
                }
            }
            return data;
        } catch (error) {
            console.error('Error verifying payment:', error);
            throw error;
        }
    };

    const handlePayment = async (e) => {
        e.preventDefault();
        // ── Helper: focus + highlight a field by name ──────────────────────────
        const focusField = (name) => {
            const el = document.querySelector(`[name="${name}"]`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
                el.focus();
                el.style.borderColor = "#c0392b";
                el.style.boxShadow = "0 0 0 3px rgba(192,57,43,0.2)";
                // Reset red border after 3 seconds
                setTimeout(() => {
                    el.style.borderColor = "";
                    el.style.boxShadow = "";
                }, 3000);
            }
        };

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.salutation) {
            alert("❌ Salutation is required");
            focusField("salutation");
            return;
        }
        if (!formData.participantName) {
            alert("❌ Participant Name is required");
            focusField("participantName");
            return;
        }
        if (!emailRegex.test(formData.email)) {
            alert("❌ Please enter a valid Email ID");
            focusField("email");
            return;
        }
        if (!formData.department) {
            alert("❌ Department is required");
            focusField("department");
            return;
        }
        if (formData.department === "Other" && !formData.otherDepartment) {
            alert("❌ Please specify your Department");
            focusField("otherDepartment");
            return;
        }
        if (!formData.designation) {
            alert("❌ Designation is required");
            focusField("designation");
            return;
        }
        if (formData.designation === "Other" && !formData.otherDesignation) {
            alert("❌ Please specify your Designation");
            focusField("otherDesignation");
            return;
        }
        if (!formData.nationality) {
            alert("❌ Nationality is required");
            focusField("nationality");
            return;
        }
        if (!formData.state) {
            alert("❌ State / Country is required");
            focusField("state");
            return;
        }

        // Phone validation
        const phoneRegex = formData.nationality === "India" ? /^[6-9]\d{9}$/ : /^\d{6,16}$/;
        if (!phoneRegex.test(formData.contactNo)) {
            alert("❌ Please enter a valid Contact Number");
            focusField("contactNo");
            return;
        }
        if (!formData.whatsappNo) {
            alert("❌ WhatsApp Number is required");
            focusField("whatsappNo");
            return;
        }

        if (!formData.collegeName) {
            alert("❌ College / Institute Name is required");
            focusField("collegeName");
            return;
        }
        if (!formData.collegeAddress) {
            alert("❌ College Address is required");
            focusField("collegeAddress");
            return;
        }
        if (!event_amount || event_amount <= 0) {
            alert("❌ Please select your Nationality to load the event amount");
            focusField("nationality");
            return;
        }

        // ── All validations passed → proceed with payment ──────────────────────

        try {
            setLoading(true); setPaymentStatus(null);
            const scriptLoaded = await loadRazorpayScript();
            if (!scriptLoaded) { alert('Failed to load Razorpay SDK. Please check your internet connection.'); setLoading(false); return; }

            const currency = formData.nationality === "India" ? "INR" : "USD";
            const orderData = await createOrder(parseFloat(formData.event_amount), currency);

            const options = {
                key: orderData.keyId,
                amount: orderData.order.amount,
                currency: orderData.order.currency,
                name: 'Aditya University',
                description: 'Event Payment',
                image: 'https://adityauniversity.in/admin/static/media/AU_LOGO.b5e661897c751649cf1f2978c02df938.svg',
                order_id: orderData.order.id,
                handler: async function (response) {
                    try {
                        const verificationResult = await verifyPayment({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                        });
                        if (!verificationResult.success) {
                            setPaymentStatus({ success: false, message: 'Payment verification failed!' });
                        }
                    } catch (error) {
                        setPaymentStatus({ success: false, message: 'Payment verification error!' });
                    }
                    setLoading(false);
                },
                prefill: { name: formData.participantName, email: formData.email, contact: formData.contactNo },
                notes: { address: formData.collegeAddress },
                theme: { color: '#3399cc' },
                modal: {
                    ondismiss: function () {
                        setLoading(false);
                        setPaymentStatus({ success: false, message: 'Payment cancelled by user' });
                    },
                },
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error('Payment error:', error);
            setPaymentStatus({ success: false, message: error.message || 'Payment failed!' });
            setLoading(false);
        }
    };

    const openPopup = (eventData) => {
        setSelectedEvent(eventData);
        setFormData({
            ...formData,
            event_amount: eventData.event_amount || "",
            event_amount_other: eventData.event_amount_other || "",
            event_name: eventData.event_name || "",
            whatsappLink: eventData.whatsappLink || ""
        });
        setShowPopup(true);
        setPaymentStatus(null);
    };

    const closePopup = () => {
        setShowPopup(false);
        setPaymentStatus(null);
        setFormData({
            applicationId: id, participantName: "", salutation: '', department: '',
            nationality: "", email: "", contactNo: "", collegeName: "", collegeAddress: "",
            state: "", category: "", designation: "", event_amount: "", event_name: "",
        });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        const fetcheventData = async () => {
            setLoading(true); setError("");
            try {
                const response = await axios.get(`${backendUrl}api/get-events`);
                const rec = response.data.event_data;
                const today = new Date().toISOString().split("T")[0];
                const todayList = [], upcomingList = [], completedList = [];
                rec.forEach((item) => {
                    const eventDate = item.event_end_date;
                    const eventStDate = item.event_start_date;
                    if (eventStDate <= today && today <= eventDate) todayList.push(item);
                    else if (eventStDate > today) upcomingList.push(item);
                    else if (eventDate < today) completedList.push(item);
                });
                setongoingEvent(todayList);
                setupcomingEvent(upcomingList);
                setcompletedEvent(completedList);
                setLoading(false);
            } catch (error) {
                console.log("Error msg display", error);
                setLoading(false);
            }
        };
        fetcheventData();
    }, [backendUrl]);

    useEffect(() => {
        if (!formData.nationality) return;
        const amount = formData.nationality === "India"
            ? selectedEvent?.event_amount
            : selectedEvent?.event_amount_other;
        setFormData((prev) => ({ ...prev, event_amount: amount || "" }));
    }, [formData.nationality, selectedEvent]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(8);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = completedEvent.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(completedEvent.length / itemsPerPage);
    const handlePageChange = (page) => setCurrentPage(page);

    const eventAmountDisplay =
        formData.nationality === "India"
            ? `₹ ${selectedEvent?.event_amount || ""}`
            : formData.nationality === "Foreign"
                ? `$ ${selectedEvent?.event_amount_other || ""}`
                : "";

    return (
        <>
            {/* Inject scoped modal styles */}


            <Header parentMenu='adityalearning' menuCategoryEnable='enable' />
            <div className="back__course__page_grid react-courses__single-page pb---16">
                <div className="react-wrapper background_height">
                    <div className="react-wrapper-inner background_image">
                        <div className="react-breadcrumbs">
                            <div className="breadcrumbs-wrap">
                                <img className="desktop" src={Banner} alt="Breadcrumbs" />
                                <img className="mobile" src={Banner} alt="Breadcrumbs" />
                                <div className="breadcrumbs-inner">
                                    <div className="container">
                                        <div className="breadcrumbs-text">
                                            <h1 className="breadcrumbs-title">Events</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="high_quality-section pt---60 pb---120">
                            <div className="container">
                                <SideManu />
                                <div className="row m-0">
                                    <div className="col-md-12 col-sm-12 col-12 bg_color" style={{ backgroundColor: "#fff" }}>
                                        <br />
                                        <Tabs selectedIndex={selectedIndex} onSelect={index => setSelectedIndex(index)}>
                                            <div className="course-single-tab">
                                                <TabList className={tabStyle}>
                                                    <Tab className='col-md-4'><button>{tab1}</button></Tab>
                                                    <Tab className='col-md-4'><button>{tab2}</button></Tab>
                                                    <Tab className='col-md-4'><button>{tab3}</button></Tab>
                                                </TabList>

                                                <TabPanel>
                                                    <b className="about__title wow animate__fadeInUp" data-wow-duration="0.5s" style={{ fontSize: "20px" }}>
                                                        <span className="hedingname_orange">Completed Events</span>
                                                    </b><br />
                                                    <div className="degree-list-container">
                                                        <ul className="degree-list">
                                                            {currentItems.map((data, index) => (
                                                                <li key={index}>
                                                                    <span className="icon">{indexOfFirstItem + index + 1}.</span> {data.event_description}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                        {totalPages > 0 && (
                                                            <ul className="pagination pagination-sm justify-content-end my-3">
                                                                <li className="page-item" onClick={() => handlePageChange(currentPage - 1)} style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>
                                                                    <button className="page-link" disabled={currentPage === 1} onClick={(e) => e.preventDefault()}>Prev</button>
                                                                </li>
                                                                {Array(totalPages).fill(null).map((_, index) => (
                                                                    <li className={`page-item ${currentPage === index + 1 ? 'active' : ''}`} key={index + 1} onClick={() => handlePageChange(index + 1)}>
                                                                        <button className="page-link" onClick={(e) => e.preventDefault()}>{index + 1}</button>
                                                                    </li>
                                                                ))}
                                                                <li className="page-item" onClick={() => handlePageChange(currentPage + 1)} style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>
                                                                    <button className="page-link" disabled={currentPage === totalPages} onClick={(e) => e.preventDefault()}>Next</button>
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </div>
                                                </TabPanel>

                                                <TabPanel>
                                                    <b className="about__title wow animate__fadeInUp" data-wow-duration="0.5s" style={{ fontSize: "20px" }}>
                                                        <span className="hedingname_orange">Ongoing Event</span>
                                                    </b><br />
                                                    <div className="degree-list-container">
                                                        {ongoingEvent.length > 0 ? (
                                                            <ul className="degree-list">
                                                                {ongoingEvent.map((data, index) => (
                                                                    <li key={index}>
                                                                        <span className="icon">{index + 1}.</span>
                                                                        {data.attachment ? (
                                                                            <Link to={`${backendUrl}/events_info/${data.attachment}`} target='_blank'>{data.event_description}</Link>
                                                                        ) : data.event_description}
                                                                        {new Date(data.reg_end_date) >= new Date(new Date().toISOString().split("T")[0]) ? (
                                                                            <button className="btn animation" style={{ marginLeft: "10px", border: "none", cursor: "pointer" }} onClick={() => openPopup(data)}>Apply Now</button>
                                                                        ) : (
                                                                            <span className="animation" style={{ marginLeft: "10px" }}>Registration Closed</span>
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : (
                                                            <div className='col-12 text-center py-5'><span className='text-danger'>{nodata}</span></div>
                                                        )}
                                                    </div>
                                                </TabPanel>

                                                <TabPanel>
                                                    <b className="about__title wow animate__fadeInUp" data-wow-duration="0.5s" style={{ fontSize: "20px" }}>
                                                        <span className="hedingname_orange">Upcoming Event</span>
                                                    </b><br />
                                                    <div className="degree-list-container row">
                                                        {upcomingEvent.length > 0 ? (
                                                            <ul className="degree-list">
                                                                {upcomingEvent.map((data, index) => (
                                                                    <li key={index} className="event-item">
                                                                        <span className="icon">{index + 1}.</span>
                                                                        <span className="event-text">
                                                                            {data.attachment ? (
                                                                                <Link to={`${backendUrl}/events_info/${data.attachment}`} target="_blank" className="more-info-btn">{data.event_description}</Link>
                                                                            ) : <span>{data.event_description}</span>}
                                                                            {new Date(data.reg_end_date) >= new Date(new Date().toISOString().split("T")[0]) ? (
                                                                                <button className="btn animation" style={{ marginLeft: "10px", border: "none", cursor: "pointer" }} onClick={() => openPopup(data)}>Apply Now</button>
                                                                            ) : (
                                                                                <span className="animation" style={{ marginLeft: "10px" }}>Registration Closed</span>
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : (
                                                            <div className="col-12 text-center py-5"><span className="text-danger">{nodata}</span></div>
                                                        )}
                                                    </div>
                                                </TabPanel>
                                            </div>
                                        </Tabs>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ════════════════════════════════════════════
                            REDESIGNED REGISTRATION MODAL
                        ════════════════════════════════════════════ */}
                        {showPopup && (
                            <div className="reg-overlay">
                                <div className="reg-modal">

                                    {/* Header */}
                                    <div className="reg-header">
                                        <button className="reg-close-btn" type="button" onClick={closePopup} title="Close">✕</button>
                                        <center> <h2 className='animation'>Registration</h2> </center>
                                        {/* <p>All fields marked * are mandatory. Name will appear exactly as entered on the certificate.</p> */}
                                    </div>

                                    {/* Form Body */}
                                    <div className="reg-body">
                                        <form onSubmit={handlePayment} id="reg-form">

                                            {/* ── Personal Information ── */}
                                            <div className="reg-section-label">Personal Information 👤</div>

                                            <div className="reg-grid-2">
                                                <div className="reg-field">
                                                    <label className="reg-field-label">Salutation <span className="req">*</span></label>
                                                    <select className="reg-select" name="salutation" value={formData.salutation} onChange={handleChange} required>
                                                        <option value="">Select</option>
                                                        {["Dr", "Mr", "Ms", "Mrs", "Other"].map(s => <option key={s} value={s}>{s}</option>)}
                                                    </select>
                                                </div>

                                                <div className="reg-field">
                                                    <label className="reg-field-label">Participant Name <span className="req">*</span></label>
                                                    <input
                                                        className="reg-input"
                                                        type="text"
                                                        name="participantName"
                                                        placeholder="FULL NAME"
                                                        maxLength={30}
                                                        value={formData.participantName}
                                                        onChange={(e) => {
                                                            let value = e.target.value.toUpperCase();
                                                            if (/^[A-Z\s]*$/.test(value) && value.length <= 30) {
                                                                handleChange({ target: { name: "participantName", value } });
                                                            }
                                                        }}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="reg-grid-2">
                                                <div className="reg-field">
                                                    <label className="reg-field-label">Email Address <span className="req">*</span></label>
                                                    <input className="reg-input" type="email" name="email" placeholder="you@example.com" maxLength={50} value={formData.email} onChange={handleChange} required />
                                                </div>

                                                <div className="reg-field">
                                                    <label className="reg-field-label">Department <span className="req">*</span></label>
                                                    <select className="reg-select" name="department" value={formData.department} onChange={handleChange} required>
                                                        <option value="">Select Department</option>
                                                        {["CSE", "EEE", "ECE", "AIML", "Civil", "IT", "IOT", "Petroleum", "Mining", "Agricultural", "Data Science", "Mechanical", "MCA", "MBA", "Other"].map(d => <option key={d} value={d}>{d}</option>)}
                                                    </select>
                                                </div>
                                            </div>

                                            {formData.department === "Other" && (
                                                <div className="reg-field">
                                                    <label className="reg-field-label">Specify Department <span className="req">*</span></label>
                                                    <input className="reg-input" type="text" name="otherDepartment" placeholder="Enter your department" maxLength={30} value={formData.otherDepartment || ""} onChange={handleChange} required />
                                                </div>
                                            )}

                                            <div className="reg-grid-2">
                                                <div className="reg-field">
                                                    <label className="reg-field-label">Designation <span className="req">*</span></label>
                                                    <select className="reg-select" name="designation" value={formData.designation} onChange={handleChange} required>
                                                        <option value="">Select Designation</option>
                                                        {["Professor", "Associate Professor", "Assistant Professor", "Other"].map(d => <option key={d} value={d}>{d}</option>)}
                                                    </select>
                                                </div>

                                                {formData.designation === "Other" ? (
                                                    <div className="reg-field">
                                                        <label className="reg-field-label">Specify Designation <span className="req">*</span></label>
                                                        <input className="reg-input" type="text" name="otherDesignation" placeholder="Enter your designation" maxLength={30} value={formData.otherDesignation || ""} onChange={handleChange} required />
                                                    </div>
                                                ) : <div />}
                                            </div>

                                            {/* ── Location & Contact ── */}
                                            <div className="reg-section-label">Location  &amp; Contact 📍</div>

                                            <div className="reg-grid-2">
                                                <div className="reg-field">
                                                    <label className="reg-field-label">Nationality <span className="req">*</span></label>
                                                    <select className="reg-select" name="nationality" value={formData.nationality} onChange={handleChange} required>
                                                        <option value="">Select</option>
                                                        <option value="India">National Participant</option>
                                                        <option value="Foreign">International Participant</option>
                                                    </select>
                                                </div>

                                                {formData.nationality === "India" && (
                                                    <div className="reg-field">
                                                        <label className="reg-field-label">State <span className="req">*</span></label>
                                                        <select className="reg-select" name="state" value={formData.state} onChange={handleChange} required>
                                                            <option value="">Select State</option>
                                                            {["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli", "Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"].map(s => <option key={s} value={s}>{s}</option>)}
                                                        </select>
                                                    </div>
                                                )}

                                                {formData.nationality === "Foreign" && (
                                                    <div className="reg-field">
                                                        <label className="reg-field-label">Country <span className="req">*</span></label>
                                                        <select
                                                            className="reg-select"
                                                            name="state"
                                                            value={formData.state}
                                                            onChange={(e) => {
                                                                const selectedCountry = countries.find(c => c.name === e.target.value);
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    state: e.target.value,
                                                                    countryCode: selectedCountry?.code || "",
                                                                    contactNo: "",
                                                                }));
                                                            }}
                                                            required
                                                        >
                                                            <option value="">Select Country</option>
                                                            {countries.map((country, index) => (
                                                                <option key={index} value={country.name}>{country.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                {!formData.nationality && <div />}
                                            </div>

                                            <div className="reg-grid-2">
                                                <div className="reg-field">
                                                    <label className="reg-field-label">Contact Number <span className="req">*</span></label>
                                                    <div className="reg-phone-row">
                                                        <div className="reg-phone-prefix">
                                                            {formData.nationality === "India" ? "+91" : (formData.countryCode || "—")}
                                                        </div>
                                                        <input
                                                            className="reg-phone-input"
                                                            type="tel"
                                                            name="contactNo"
                                                            placeholder="Mobile number"
                                                            value={formData.contactNo}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, "");
                                                                const maxLength = formData.nationality === "India" ? 10 : 16;
                                                                if (value.length <= maxLength) {
                                                                    setFormData(prev => ({ ...prev, contactNo: value }));
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="reg-field">
                                                    <label className="reg-field-label">WhatsApp Number <span className="req">*</span></label>
                                                    <div className="reg-phone-row">
                                                        <div className="reg-phone-prefix">
                                                            {formData.nationality === "India" ? "+91" : (formData.countryCode || "—")}
                                                        </div>
                                                        <input
                                                            className="reg-phone-input"
                                                            type="tel"
                                                            name="whatsappNo"
                                                            placeholder="WhatsApp number"
                                                            value={formData.whatsappNo}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, "");
                                                                const max = formData.nationality === "India" ? 10 : 16;
                                                                if (value.length <= max) {
                                                                    setFormData(prev => ({ ...prev, whatsappNo: value }));
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (!formData.whatsappNo) return;
                                                                if (formData.nationality === "India" && formData.whatsappNo.length !== 10) {
                                                                    alert("WhatsApp number must be exactly 10 digits.");
                                                                }
                                                                if (formData.nationality !== "India" && formData.whatsappNo.length < 6) {
                                                                    alert("Please enter a valid international number.");
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ── Organisation ── */}
                                            <div className="reg-section-label">Organisation 🏢</div>

                                            <div className="reg-field">
                                                <label className="reg-field-label">Name of the College/ Institute/University/ Industry/ other Professional bodies <span className="req">*</span></label>
                                                <input
                                                    className="reg-input"
                                                    type="text"
                                                    name="collegeName"
                                                    placeholder="Enter organisation name"
                                                    maxLength={50}
                                                    value={formData.collegeName}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^[A-Za-z\s]*$/.test(value) || value === "") handleChange(e);
                                                    }}
                                                    required
                                                />
                                            </div>

                                            <div className="reg-field">
                                                <label className="reg-field-label">Address of the College/ Institute/ University/ Industry/ Other Professional bodies <span className="req">*</span></label>
                                                <textarea className="reg-input reg-textarea" name="collegeAddress" placeholder="Enter Address" maxLength={100} value={formData.collegeAddress} onChange={handleChange} rows={2} required />
                                            </div>

                                            {/* ── Event Details ── */}
                                            <div className="reg-section-label">Event Details 🌟</div>
                                            <div className="reg-event-card">
                                                <div className="reg-event-name">{selectedEvent?.event_name || "—"}</div>
                                                <div className="reg-event-amount">{eventAmountDisplay || "—"}</div>
                                            </div>

                                            {/* Hidden fields */}
                                            <input type="hidden" name="whatsappLink" value={selectedEvent?.whatsappLink || ""} />

                                        </form>

                                    </div>

                                    {/* Payment result */}
                                    {paymentStatus && (
                                        <div className={`reg-payment-result ${paymentStatus.success ? "success" : "failure"}`}>
                                            <h3>{paymentStatus.success ? "✅ Payment Successful" : "❌ Payment Failed"}</h3>
                                            {paymentStatus.paymentId && (
                                                <>
                                                    <p><strong>Payment ID:</strong> {paymentStatus.paymentId}</p>
                                                    <p><strong>UTR No:</strong> {paymentStatus.utr}</p>
                                                </>
                                            )}
                                        </div>
                                    )}

                                    {/* Footer */}
                                    <div className="reg-footer">
                                        <button type="button" className="reg-btn-cancel" onClick={closePopup}>Cancel</button>
                                        <button type="submit" form="reg-form" className="reg-btn-pay" disabled={loading} onClick={handlePayment}>
                                            {loading ? <><span className="reg-spinner" />Processing…</> : "Proceed to Payment"}
                                        </button>
                                    </div>
                                    <div class="notice-banner">
                                        ⚠️ <span>Note:</span> The server will undergo maintenance daily from
                                        <strong> 4:00 PM to 4:30 PM</strong>. Kindly avoid registrations during this period.
                                    </div>
                                </div>

                            </div>
                        )}
                        {/* ── END MODAL ── */}

                        {/* Success overlay */}
                        {showSuccess && (
                            <div className="reg-success-overlay">
                                <div className="reg-success-box">
                                    <span className="reg-success-icon">🎉</span>
                                    <h3>Registration Successful!</h3>
                                    <p>Your registration is confirmed. Download your receipt below.</p>
                                    <button
                                        className="reg-btn-download"
                                        onClick={() => { downloadReceipt(); setShowSuccess(false); }}
                                    >
                                        📥 Download Receipt
                                    </button>
                                </div>
                            </div>
                        )}

                        <ScrollToTop />
                    </div>
                </div>
            </div>
            <FooterTwo />
        </>
    );
};

export default AdvancedAppliation;